import CheckBattery1 from '../../../assets/images/checkbattery/batt-01.webp'
import CheckBattery2 from '../../../assets/images/checkbattery/batt-02.webp'
import CheckBattery3 from '../../../assets/images/checkbattery/batt-03.webp'
import CheckBattery4 from '../../../assets/images/checkbattery/batt-04.webp'
import recommendIcon1 from "../../../assets/images/recommendations/recommend-1.svg"
import recommendIcon2 from "../../../assets/images/recommendations/recommend-2.svg"
import recommendIcon3 from "../../../assets/images/recommendations/recommend-3.svg"
import CheckModel1 from '../../../assets/images/checkmodel/check-model-1.webp'
import CheckModel2 from '../../../assets/images/checkmodel/check-model-2.webp'
import CheckModel3 from '../../../assets/images/checkmodel/check-model-3.webp'
import Accessories1 from '../../../assets/images/accessories/acc-1.png'
import Accessories2 from '../../../assets/images/accessories/acc-2.png'
import Warranty1 from '../../../assets/images/checkwarranty/warranty-1.webp'
import Warranty2 from '../../../assets/images/checkwarranty/warranty-2.webp'
import Warranty3 from '../../../assets/images/checkwarranty/warranty-3.webp'
import Used1 from '../../../assets/images/checkused/used-1.png'
import Used2 from '../../../assets/images/checkused/used-2.png'
import Used3 from '../../../assets/images/checkused/used-3.png'
import Used4 from '../../../assets/images/checkused/used-4.png'
import Used5 from '../../../assets/images/checkused/used-5.png'
import Frame1 from '../../../assets/images/framecodition/frame-condition-1.webp'
import Frame2 from '../../../assets/images/framecodition/frame-condition-2.webp'
import Frame3 from '../../../assets/images/framecodition/frame-condition-3.webp'
// import Frame4 from '../../../assets/images/framecodition/frame-condition-4.webp'
import Frame5 from '../../../assets/images/framecodition/frame-condition-5.webp'
import Frame6 from '../../../assets/images/framecodition/frame-condition-6.webp'
import Display1 from '../../../assets/images/display/display-1.webp'
import Display2 from '../../../assets/images/display/display-2.webp'
import Display3 from '../../../assets/images/display/display-3.webp'
import Display4 from '../../../assets/images/display/display-4.webp'
import Display5 from '../../../assets/images/display/display-5.webp'
import Backframe1 from '../../../assets/images/backframe/backframe-1.webp'
import Backframe2 from '../../../assets/images/backframe/backframe-2.webp'
import Backframe3 from '../../../assets/images/backframe/backframe-3.webp'
import Backframe4 from '../../../assets/images/backframe/backframe-4.webp'
import Backcamera1 from '../../../assets/images/backcamera/backcamera-1.webp'
import Backcamera2 from '../../../assets/images/backcamera/backcamera-2.webp'
import Backcamera3 from '../../../assets/images/backcamera/backcamera-3.webp'
import Backcamera4 from '../../../assets/images/backcamera/backcamera-4.webp'
import UC101 from '../../../assets/images/conditions/UC-101.webp'
import UC103 from '../../../assets/images/conditions/UC-103.webp'
import UC104 from '../../../assets/images/conditions/UC-104.webp'
import UC105 from '../../../assets/images/conditions/UC-105.webp'
import UC106_1 from '../../../assets/images/conditions/UC-106-1.webp'
import UC106_2 from '../../../assets/images/conditions/UC-106-2.webp'
import UC107 from '../../../assets/images/conditions/UC-107.webp'
import UC110_1 from '../../../assets/images/conditions/UC-110-1.webp'
import UC110_2 from '../../../assets/images/conditions/UC-110-2.webp'
import UC111 from '../../../assets/images/conditions/UC-111.webp'
import UC112 from '../../../assets/images/conditions/UC-112.webp'
import UC113_1 from '../../../assets/images/conditions/UC-113-1.webp'
import UC113_2 from '../../../assets/images/conditions/UC-113-2.webp'


export const CONDITIONUC113 = [
  {
    image: UC113_1,
    text: "ตกน้ำ",
    col: 24
  },
  {
    image: UC113_2,
    text: "แถบวัดความชื้นเปลี่ยนสี",
    col: 24
  },
]

export const CONDITIONUC103 = [
  {
    image: UC103,
    text: "ไม่ดัง / เสียงแตก",
    col: 24
  },
]

export const CONDITIONUC104 = [
  {
    image: UC104,
    text: "ปุ่มกดใช้งานไม่ได้ ",
    col: 24
  },
]

export const CONDITIONUC105 = [
  {
    image: UC105,
    text: "ชาร์จไม่เข้า หรือชาร์จเข้าแต่เปอร์เซนต์ไม่ขึ้น",
    col: 24
  },
]

export const CONDITIONUC106 = [
  {
    image: UC106_1,
    text: "สีเพี้ยน / เส้น / จุด",
    col: 24
  },
  {
    image: UC106_2,
    text: "ไม่ติด",
    col: 24
  },
]


export const CONDITIONUC107 = [
  {
    image: UC107,
    text: "สแกนหน้า หรือนิ้วไม่ได้",
    col: 24
  },
]

export const CONDITIONUC110 = [
  {
    image: UC110_1,
    text: "ระบบใช้งานไม่ได้ / ใช้งานไม่ปกติ",
    col: 24
  },
  {
    image: UC110_2,
    text: "ระบบใช้งานไม่ได้ / ใช้งานไม่ปกติ",
    col: 24
  },
]


export const CONDITIONUC111 = [
  {
    image: UC111,
    text: "โทรออกรับสาย ไม่ได้",
    col: 24
  },
]

export const CONDITIONUC112 = [
  {
    image: UC112,
    text: "ใช้งานไม่ได้",
    col: 24
  },
]




export const CONDITIONUC101 = [
  {
    image: UC101,
    text: "ใช้งานไม่ได้ / มีจุด / โดนเลเซอร์",
    col: 24
  },
]

export const CONDITIONUC102 = [
  {
    image: UC101,
    text: "ใช้งานไม่ได้ / มีจุด / โดนเลเซอร์",
    col: 24
  },
]

export const BACKCAMERAHELP = [
  {
    image: Backcamera1,
    text: "ไม่มีรอย",
    col: 8
  },
  {
    image: Backcamera2,
    text: "มีรอยเล็กน้อย",
    col: 8
  },
  {
    image: Backcamera3,
    text: "มีรอยชัดเจน รอยเยอะ สีลอก",
    col: 8
  },
  {
    image: Backcamera4,
    text: "มีรอยตก แตก",
    col: 8
  },
]


export const BACKFRAMEHELP = [
  {
    image: Backframe1,
    text: "ไม่มีรอย",
    col: 8
  },
  {
    image: Backframe2,
    text: "มีรอยเล็กน้อย",
    col: 8
  },
  {
    image: Backframe3,
    text: "มีรอยชัดเจน รอยเยอะ สีลอก",
    col: 8
  },
  {
    image: Backframe4,
    text: "มีรอยตก แตก",
    col: 8
  },
]



export const DISPLAYHELP = [
  {
    image: Display1,
    text: "ใหม่ยังไม่แกะ",
    col: 8
  },
  {
    image: Display2,
    text: "ไม่มีรอย",
    col: 8
  },
  {
    image: Display3,
    text: "มีรอยเล็กน้อย รอยบางๆ",
    col: 8
  },
  {
    image: Display4,
    text: "มีรอยเยอะ รอยสะดุด",
    col: 8
  },
  {
    image: Display5,
    text: "มีรอยแตก ร้าว",
    col: 8
  }
]


export const BATTERYHELP = [
  {
    image: CheckBattery1,
    text: "1. เข้าไปที่ ‘การตั้งค่า’",
    col: 8
  },
  {
    image: CheckBattery2,
    text: "2. เลือก ‘แบตเตอรี่’",
    col: 8
  },
  {
    image: CheckBattery3,
    text: "3. เลือก ‘สุขภาพแบตเตอรี่’",
    col: 8
  },
  {
    image: CheckBattery4,
    text: "แบตเตอรี่บวม",
    col: 8
  }
]

export const MODELHELP = [
  {
    image: CheckModel1,
    text: "เข้าเมนูตั้งค่า > ทั่วไป",
    col: 8
  },
  {
    image: CheckModel2,
    text: "เลือก 'เกี่ยวกับ'",
    col: 8
  },
  {
    image: CheckModel3,
    text: "หมายเลขรุ่น",
    col: 8
  },

]
export const ACCESSORIESHELP = [
  {
    image: Accessories1,
    text: "",
    col: 12
  },
  {
    image: Accessories2,
    text: "",
    col: 12
  },
]
export const WARRANTYHELP = [
  {
    image: Warranty1,
    text: "1.เข้าเมนูตั้งค่า > ทั่วไป",
    col: 8
  },
  {
    image: Warranty2,
    text: "2.เลือก 'เกี่ยวกับ'",
    col: 8
  },
  {
    image: Warranty3,
    text: `ความคุ้มครอง`,
    col: 8
  },
]

export const USEDHELP = [
  {
    image: Used1,
    text: "มีรอยมาก ถลอก สีหลุด",
    col: 8
  },
  {
    image: Used2,
    text: "มีรอยรอบเครื่องเล็กน้อย-รอยเคส",
    col: 8
  },
  {
    image: Used3,
    text: "มีรอยลึก 1 จุด ไม่มีผลต่อการใช้งาน",
    col: 8
  },
  {
    image: Used4,
    text: "เลนส์กล้องมีปัญหา มีฟองอากาศ",
    col: 8
  },
  {
    image: Used5,
    text: "หน้าจอมีรอยบางๆ",
    col: 8
  },
]

export const FRAMECONDITION = [
  {
    image: Frame1,
    text: "ใหม่ยังไม่แกะ",
    col: 8
  },
  {
    image: Frame2,
    text: "ไม่มีรอย",
    col: 8
  },
  {
    image: Frame3,
    text: "มีรอยนิดหน่อย",
    col: 8
  },
  {
    image: Frame5,
    text: "มีรอยมาก สีถลอก น็อตเป็นสนิม",
    col: 8
  },
  {
    image: Frame6,
    text: "มีรอยตก บุบ แตก งอ",
    col: 8
  }
]

export const RECOMENDDETAIL = () => {
  return [
    {
      icon: recommendIcon1,
      title: "เอกสารยืนยันตัวตนผู้ขาย",
      description: "กรุณาเตรียมบัตรประชาชนหรือสำเนาบัตรประชาชนของผู้ขาย ผู้ขายจะต้องมาอายุ 20 ปีขึ้นไป และบัตรประชาชนจะต้องยังไม่หมดอายุ ในกรณีท่านอายุต่ำว่า 20 ปีบริบูรณ์เราขอให้ท่านแสดงหลักฐานว่าได้รับความยินยอมของบิดามารดาหรือผู้ปกครองแล้ว"
    },
    {
      icon: recommendIcon2,
      title: "การสำรองข้อมูล",
      description: "กรุณาสำรองข้อมูลที่สำคัญ เนื่องจากทางบริษัทฯ จะทำการล้างเครื่องคืนกลับสู่สภาพโรงงานหลังการขายเสร็จสิ้น"
    },
    {
      icon: recommendIcon3,
      title: "ชาร์จแบตเตอรี่ให้เต็ม",
      description: "กรุณาชาร์จแบตเตอรี่ให้เต็ม เพื่อความสะดวกในการตรวจเช็กสภาพเครื่องที่ต้องการขาย"
    },
  ]
}



export const LOCALETH = { locale: 'th', month: 'เดือน', year: 'ปี', today: 'วันนี้', now: 'ตอนนี้', backToToday: 'กลับไปที่วันนี้', ok: 'ตกลง', clear: 'ล้าง', monthSelect: 'เลือกเดือน', yearSelect: 'เลือกปี', decadeSelect: 'เลือกทศวรรษ', yearFormat: 'YYYY', monthFormat: 'MMMM', dateFormat: 'D/M/YYYY', dayFormat: 'D', dateTimeFormat: 'D/M/YYYY HH:mm:ss', monthBeforeYear: true, }


export const postalCodeData = [
  "10600", "10510", "10110", "10230", "10900", "10150", "10210", "10400",
  "10300", "10170", "10170", "10140", "10600", "10700", "10600", "10240",
  "10150", "10120", "10800", "10260", "10150", "10700", "10500", "10220",
  "10160", "10240", "10330", "10250", "10100", "10400", "10200", "10260",
  "10160", "10510", "10120", "10400", "10140", "10520", "10230", "10310",
  "10110", "10250", "10240", "10100", "10120", "10220", "10530", "10160",
  "10210", "10310", "11130", "11110", "11140", "11120", "11000", "11150",
  "74110", "74120", "74000", "12120", "12130", "12140", "12130", "12160",
  "12170", "12000", "10560", "10540", "10540", "10130", "10290", "10270"
];

export const optionOnSiteTime = [
  { value: "11:00", label: "11:00" },
  { value: "12:00", label: "12:00" },
  { value: "13:00", label: "13:00" },
  { value: "14:00", label: "14:00" },
  { value: "15:00", label: "15:00" },
  { value: "16:00", label: "16:00" },
  { value: "17:00", label: "17:00" },
  { value: "18:00", label: "18:00" },
  { value: "19:00", label: "19:00" },
];

export const optionDeliveryTime = [
  { value: "10:00", label: "10:00" },
  { value: "11:00", label: "11:00" },
  { value: "12:00", label: "12:00" },
  { value: "13:00", label: "13:00" },
  { value: "14:00", label: "14:00" },
  { value: "15:00", label: "15:00" },
  { value: "16:00", label: "16:00" },
  { value: "17:00", label: "17:00" },
  { value: "18:00", label: "18:00" },
  { value: "19:00", label: "19:00" },

];